import axios from "axios";

// interfaces
import { LoginFormData } from "../../interfaces/store/auth";

import { API_BASE_URL } from "../../config/api";

// Login
const login = async (formData: LoginFormData) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
        },
    };

    const { data } = await axios.post(
        `${API_BASE_URL}/super-admin/auth`,
        formData,
        config
    );
    return data;
};

// Logout
const logout = async (token: string) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const { data } = await axios.post(
        `${API_BASE_URL}/super-admin/logout`,
        {},
        config
    );
    return data;
};

// me
const me = async (token: string) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const { data } = await axios.post(
        `${API_BASE_URL}/super-admin/me`,
        {},
        config
    );
    return data;
};

const authServices = {
    login,
    logout,
    me,
};

export default authServices;
